import {
  FilterCriteriaForm,
  FiltersCriteriaInputForm,
  SingleFilterForm,
} from '@/components/table/schemas/filterCriteriaSchema.ts';

export const emptyFilter = {} as SingleFilterForm;

/** Panel otwiera się na tym, co tabela naprawdę filtruje — inaczej filtr z adresu byłby niewidoczny, a „Zastosuj” by go skasował. */
export const filterFormDefaults = (
  criteria: FilterCriteriaForm,
): FiltersCriteriaInputForm => ({
  combinator: criteria.combinator,
  filters: criteria.filters.length > 0 ? criteria.filters : [emptyFilter],
});
